export default __webpack_public_path__ + "static/media/blue-zp-image.c52f722e.png";